import React from 'react';
import DateRangePicker from '../DateRangePicker';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/heatmap';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/visualMap';
import 'echarts/lib/component/transform';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const anthrax_monthly_data = [[2005, 0, 3], [2005, 1, 1], [2005, 2, 4], [2005, 3, 2], [2005, 4, 3], [2005, 5, 4], [2005, 6, 12], [2005, 7, 5], [2005, 8, 4], [2005, 9, 4], [2005, 10, 5], [2005, 11, 3], [2006, 0, 3], [2006, 1, 2], [2006, 2, 2], [2006, 3, 3], [2006, 4, 2], [2006, 5, 4], [2006, 6, 7], [2006, 7, 13], [2006, 8, 5], [2006, 9, 5], [2006, 10, 6], [2006, 11, 2], [2007, 0, 1], [2007, 1, 0], [2007, 2, 0], [2007, 3, 3], [2007, 4, 5], [2007, 5, 4], [2007, 6, 10], [2007, 7, 9], [2007, 8, 5], [2007, 9, 8], [2007, 10, 5], [2007, 11, 6], [2008, 0, 3], [2008, 1, 0], [2008, 2, 2], [2008, 3, 2], [2008, 4, 8], [2008, 5, 9], [2008, 6, 5], [2008, 7, 6], [2008, 8, 12], [2008, 9, 3], [2008, 10, 2], [2008, 11, 4], [2009, 0, 7], [2009, 1, 1], [2009, 2, 5], [2009, 3, 4], [2009, 4, 4], [2009, 5, 4], [2009, 6, 7], [2009, 7, 14], [2009, 8, 5], [2009, 9, 2], [2009, 10, 4], [2009, 11, 4], [2010, 0, 1], [2010, 1, 1], [2010, 2, 2], [2010, 3, 1], [2010, 4, 1], [2010, 5, 3], [2010, 6, 10], [2010, 7, 6], [2010, 8, 1], [2010, 9, 2], [2010, 10, 1], [2010, 11, 3], [2011, 0, 1], [2011, 1, 3], [2011, 2, 2], [2011, 3, 4], [2011, 4, 5], [2011, 5, 2], [2011, 6, 6], [2011, 7, 17], [2011, 8, 9], [2011, 9, 4], [2011, 10, 9], [2011, 11, 6], [2012, 0, 8], [2012, 1, 5], [2012, 2, 2], [2012, 3, 8], [2012, 4, 5], [2012, 5, 7], [2012, 6, 3], [2012, 7, 4], [2012, 8, 4], [2012, 9, 7], [2012, 10, 8], [2012, 11, 3], [2013, 0, 7], [2013, 1, 3], [2013, 2, 3], [2013, 3, 5], [2013, 4, 6], [2013, 5, 6], [2013, 6, 14], [2013, 7, 10], [2013, 8, 7], [2013, 9, 15], [2013, 10, 10], [2013, 11, 4], [2014, 0, 6], [2014, 1, 4], [2014, 2, 3], [2014, 3, 5], [2014, 4, 5], [2014, 5, 2], [2014, 6, 11], [2014, 7, 21], [2014, 8, 10], [2014, 9, 6], [2014, 10, 11], [2014, 11, 8], [2015, 0, 6], [2015, 1, 5], [2015, 2, 1], [2015, 3, 7], [2015, 4, 5], [2015, 5, 5], [2015, 6, 15], [2015, 7, 20], [2015, 8, 10], [2015, 9, 8], [2015, 10, 5], [2015, 11, 9], [2016, 0, 1], [2016, 1, 4], [2016, 2, 7], [2016, 3, 3], [2016, 4, 11], [2016, 5, 4], [2016, 6, 8], [2016, 7, 17], [2016, 8, 17], [2016, 9, 10], [2016, 10, 8], [2016, 11, 6], [2017, 0, 7], [2017, 1, 2], [2017, 2, 2], [2017, 3, 6], [2017, 4, 8], [2017, 5, 4], [2017, 6, 22], [2017, 7, 27], [2017, 8, 14], [2017, 9, 8], [2017, 10, 7], [2017, 11, 5], [2018, 0, 2], [2018, 1, 5], [2018, 2, 4], [2018, 3, 5], [2018, 4, 0], [2018, 5, 8], [2018, 6, 5], [2018, 7, 11], [2018, 8, 9], [2018, 9, 7], [2018, 10, 3], [2018, 11, 2], [2019, 0, 2], [2019, 1, 3], [2019, 2, 3], [2019, 3, 2], [2019, 4, 4], [2019, 5, 2], [2019, 6, 5], [2019, 7, 7], [2019, 8, 3], [2019, 9, 4], [2019, 10, 1], [2019, 11, 0]];

class MonthlyHeatmapChart extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      startYear: 2005,
      endYear: 2019,
      startMonth: 1,
      endMonth: 12
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    if (parseInt(this.state.startYear) > parseInt(this.state.endYear)) {
      alert(`Invalid year range from ${this.state.startYear} to ${this.state.endYear}.`);
      return;
    } else if (parseInt(this.state.startMonth) > parseInt(this.state.endMonth)) {
      alert(`Invalid month range from ${months[this.state.startMonth - 1]} to ${months[this.state.endMonth - 1]}.`);
      return;
    } else {
      // create dataset filter
      var filter_data = anthrax_monthly_data.filter((monthly_data) => {
        if (parseInt(monthly_data[0]) < parseInt(this.state.startYear) ||
          parseInt(monthly_data[0]) > parseInt(this.state.endYear) ||
          parseInt(monthly_data)[1] + 1 < parseInt(this.state.startMonth) ||
          parseInt(monthly_data[1] + 1) > parseInt(this.state.endMonth)) {
          return false;
        } else {
          return true;
        }
      });
      // find maximum of visual map
      var max = Math.max.apply(null, filter_data.map((monthly_data) => monthly_data[2]));
      // update chart
      this.myChart.setOption({
        xAxis: {
          type: 'category',
        },
        yAxis: {
          type: 'category',
          data: months.slice(this.state.startMonth - 1, this.state.endMonth),
          inverse: true,
        },
        visualMap: {
          min: 0,
          max: max,
          calculable: true,
          orient: 'horizontal',
          top: 'bottom',
          left: 'center'
        },
        series: {
          name: 'Number of cases',
          type: 'heatmap',
          data: filter_data,
          label: {
            show: true,
            fontSize: 12,
            fontWeight: 300,
          }
        }
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }
  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme, 'EN');
    this.myChart = echarts.init(document.getElementById('monthly-heatmap-chart'), 'customColorTheme');
    var option = {
      animation: true,
      grid: {
        left: 'center',
        width: '70%',
        top: '3%',
        height: '80%',
      },
      tooltip: {
        formatter: (params) => {
          return `${params.seriesName}<br/>${params.marker} ${months[params.value[1] + 1]} ${params.value[0]}&emsp;&ensp;<b>${params.value[2]}</b>`
        }
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        // data: years,
      },
      yAxis: {
        type: 'category',
        data: months,
        inverse: true,
      },
      visualMap: {
        min: 0,
        max: 27,
        calculable: true,
        orient: 'horizontal',
        top: 'bottom',
        left: 'center',
        // bottom: '5%'
      },
      series: {
        name: 'Number of cases',
        type: 'heatmap',
        data: anthrax_monthly_data,
        label: {
          show: true,
          fontSize: 12,
          fontWeight: 300,
        }
      }
    };
    this.myChart.setOption(option);
  }
  render() {
    return (
      <>
        <DateRangePicker
          startYear={this.state.startYear}
          endYear={this.state.endYear}
          startMonth={this.state.startMonth}
          endMonth={this.state.endMonth}
          onChange={this.handleInputChange}
          onClick={this.handleSubmit}
        />
        <div class="m-auto" id="monthly-heatmap-chart" style={{ height: '500px' }}></div>
      </>
    );
  }
}

export default MonthlyHeatmapChart;